export class WhoAmI {
    public static IAM: string;

    /**
     * Indicates that the logged in user is only authorised to perform beacon scans
     */
    static beaconScanOnly: boolean;

    static iAmHOS(): boolean {
        return WhoAmI.IAM === "HOS";
    }
}

export class Config {
    public static START_HOUR_OF_DAY = "preference/afj.fedelta.time.startHourOfDay";
    public static LOCALISATION = "preference/afj.fedelta.localisation.enableLocalisation";
    public static PRODUCTLINE_PROMPT_FOR_PRICE_DEFAULT_OPTIONS = "preference/afj.fedelta.pos.products.showpromptforpricedefautoptions";
    public static REASONS_ALLOW_COMMENTS = "preference/afj.fedelta.pos.sales.allowReasonComments";
    public static CLIENT_ID = "preference/afj.fedelta.webproxy.clientId";
    public static INTERCOM_ENABLED = "preference/afj.fedelta.wbo.enableIntercom";
    public static INTERCOM_APP_ID = "preference/afj.fedelta.wbo.intercomAppId";
    public static MIX_AND_MATCH_ALLOW_CONSUME_MOST_EXPENSIVE = "preference/afj.fedelta.pos.orders.mixAndMatchAllowConsumeMostExpensive";
    public static VENDORS_GENERATE_PURCHASE_ORDER_CSV = "preference/afj.fedelta.backoffice.vendors.generateCsv";
    public static BACKOFFICE_USER_REQUEST_PROFILE_COMPLETION = "preference/afj.fedelta.backoffice.user.requestProfileCompletion";
    public static BACKOFFICE_PRICING_MAINTAIN_SURCHARGE_DISCOUNT_INTERACTION_VIA = "preference/afj.fedelta.backoffice.pricing.maintainSurchargeDiscountInteractionVia";
    public static BI_ENABLED = "preference/afj.fedelta.bi.enabled";
    public static EMAIL_ADDRESS = "preference/afj.fedelta.email.emailAddress";
    public static EMAIL_ALLOW_OVERRIDE_ADDRESS = "preference/afj.fedelta.email.allowOverrideAddress";
    public static EMAIL_HOST = "preference/afj.fedelta.email.emailHost";
    public static EXTERNAL_APP_ENABLED = "preference/afj.fedelta.app.enableExternalApps";
    public static TOTANGO_SERVICE_ID = "preference/afj.fedelta.totango.serviceId";
    public static LIGHTSPEEDK_API_URL = "preference/afj.fedelta.lightspeedk.apiUrl";
    public static LIGHTSPEEDK_CLIENT_ID = "preference/afj.fedelta.lightspeedk.clientId";
    public static LIGHTSPEEDK_WEBHOOK_URL = "preference/afj.fedelta.lightspeedk.webhookUrl";
    public static LIGHTSPEEDK_AUTH_REDIRECT_URL = "preference/afj.fedelta.lightspeedk.authRedirectUrl";
    public static API_INSTANCE_REGISTERED = "api/instanceRegistered";
}

export class Plugin {
    public static LOYALTY = "plugin/au.com.afjsoftware.pos.plugin.loyalty.server";
    public static TYRO = "plugin/au.com.afjsoftware.pos.plugin.tyro.server";
}

export class License {
    public static RESDIARY = "license/au.com.afjsoftware.pos.plugin.core.resdiary";
    public static OPENTABLE = "license/au.com.afjsoftware.pos.plugin.core.opentable";
    public static YELLO = "license/au.com.afjsoftware.pos.plugin.core.yello";
    public static GIVEX = "license/au.com.afjsoftware.pos.plugin.core.givex";
    public static KVD = "license/au.com.afjsoftware.pos.plugin.core.kvd";
    public static EZYPAY = "license/au.com.afjsoftware.pos.plugin.core.ezypay";
    public static TYROFOOD = "license/au.com.afjsoftware.pos.plugin.core.tyrofood";
    public static TYROBOOKING = "license/au.com.afjsoftware.pos.plugin.core.tyrobooking";
    public static DOORDASHDRIVE = "license/au.com.afjsoftware.pos.plugin.core.doordashdrive";
}

export class Local {
    public static TEST = "local/test";
    public static CLIENT_ID = "local/clientId";
    public static DATASERVER_URL = "local/dataserverURL";
    public static WHOAMI = "local/whoAmI";
}

export class ServerAuth {
    public static REBALANCE_TILL = "authorisation/bo.rebalancetill";
    public static PUBLISH_BI_DASHBOARD = "authorisation/bo.publishbidashboard";
    public static PERFORM_REFUND_PAYMENT = "authorisation/bo.performrefundpayment";
    public static INTERNAL_SUPPORT_FULL_ACCESS = "authorisation/bo.internal.support.full-access";
    public static UPDATE_PRODUCT_LINE = "authorisation/bo.updateproductline";
    public static MOVE_CATEGORY = "authorisation/bo.performcategorymove";
    public static UPDATE_CATEGORY = "authorisation/bo.updatecategory";
}

export class AppAuth {
    public static TEST = "authorisation/wbo.test";
}
